export default "__VITE_ASSET__C9O5gRG9__"